import { useMemo } from "react";
import { useSinkState, useSinkActions } from "../context/sink";

export default () => {
  const { surveyListExpansion } = useSinkState();
  const { toggleSurveyExpansion, expandAllSurveys, collapseAllSurveys } =
    useSinkActions();

  return useMemo(
    () => ({
      isExpanded: (surveyId: number) => surveyListExpansion[surveyId] ?? false,
      toggle: toggleSurveyExpansion,
      expandAll: expandAllSurveys,
      collapseAll: collapseAllSurveys,
    }),
    [
      surveyListExpansion,
      toggleSurveyExpansion,
      expandAllSurveys,
      collapseAllSurveys,
    ]
  );
};

